/**
 * Mobile Navigation Tabs
 * Handles tab switching with Motion.js animations and Swiper carousels
 */

(function () {
  'use strict';

  const promoSwipers = new Map(); // Store swiper instances

  function initPromoSwiper(swiperElement) {
    const swiperId = swiperElement.dataset.promoSwiper;

    // Destroy existing swiper if it exists
    if (promoSwipers.has(swiperId)) {
      const existingSwiper = promoSwipers.get(swiperId);
      if (existingSwiper && existingSwiper.destroy) {
        existingSwiper.destroy(true, true);
      }
      promoSwipers.delete(swiperId);
    }

    // Initialize new swiper
    if (typeof Swiper !== 'undefined') {
      const swiper = new Swiper(swiperElement, {
        slidesPerView: 2,
        spaceBetween: 2,
        grabCursor: true,
        watchOverflow: true,
      });

      promoSwipers.set(swiperId, swiper);
    }
  }

  function initAllPromoSwipers() {
    const mobileNavTabs = document.querySelector('.mobile-nav-tabs');
    if (!mobileNavTabs) return;

    // Wait for Swiper to be available
    function waitForSwiper(callback) {
      if (typeof Swiper !== 'undefined') {
        callback();
      } else {
        setTimeout(() => waitForSwiper(callback), 50);
      }
    }

    waitForSwiper(() => {
      const swipers = mobileNavTabs.querySelectorAll('[data-promo-swiper]');
      swipers.forEach((swiperEl) => {
        // Only initialize swipers in active panels
        const panel = swiperEl.closest('.mobile-nav-tabs__panel');
        if (panel && panel.classList.contains('is-active')) {
          initPromoSwiper(swiperEl);
        }
      });
    });
  }

  function initMobileNavTabs() {
    const mobileNavTabs = document.querySelector('.mobile-nav-tabs');

    if (!mobileNavTabs) {
      return;
    }

    const tabs = mobileNavTabs.querySelectorAll('.mobile-nav-tabs__tab');
    const panels = mobileNavTabs.querySelectorAll('.mobile-nav-tabs__panel');

    if (tabs.length === 0 || panels.length === 0) {
      return;
    }

    // Wait for Motion.js to be available
    function waitForMotion(callback) {
      if (
        typeof Motion !== 'undefined' &&
        typeof Motion.animate === 'function'
      ) {
        callback();
      } else {
        setTimeout(() => waitForMotion(callback), 50);
      }
    }

    waitForMotion(() => {
      setupTabSwitching();
      // Initialize swipers for initially active panel
      setTimeout(initAllPromoSwipers, 100);
    });

    function setupTabSwitching() {
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          const tabId = tab.dataset.tab;
          const targetPanel = mobileNavTabs.querySelector(
            `.mobile-nav-tabs__panel[data-panel="${tabId}"]`
          );

          if (!targetPanel || tab.classList.contains('is-active')) {
            return;
          }

          // Get currently active tab and panel
          const activeTab = mobileNavTabs.querySelector(
            '.mobile-nav-tabs__tab.is-active'
          );
          const activePanel = mobileNavTabs.querySelector(
            '.mobile-nav-tabs__panel.is-active'
          );

          if (activeTab && activePanel) {
            // Animate out current panel
            Motion.animate(
              activePanel,
              {
                opacity: [1, 0],
                transform: ['translateX(0px)', 'translateX(-20px)'],
              },
              {
                duration: 0.3,
                easing: [0.4, 0, 0.2, 1],
              }
            ).then(() => {
              // Remove active classes
              activeTab.classList.remove('is-active');
              activeTab.setAttribute('aria-selected', 'false');
              activePanel.classList.remove('is-active');

              // Set new active tab
              tab.classList.add('is-active');
              tab.setAttribute('aria-selected', 'true');

              // Show new panel
              targetPanel.classList.add('is-active');

              // Initial state for animation
              targetPanel.style.opacity = '0';
              targetPanel.style.transform = 'translateX(20px)';

              // Animate in new panel
              requestAnimationFrame(() => {
                Motion.animate(
                  targetPanel,
                  {
                    opacity: [0, 1],
                    transform: ['translateX(20px)', 'translateX(0px)'],
                  },
                  {
                    duration: 0.4,
                    easing: [0.4, 0, 0.2, 1],
                  }
                ).then(() => {
                  // Clean up inline styles
                  targetPanel.style.opacity = '';
                  targetPanel.style.transform = '';
                  // Initialize swiper for newly active panel
                  setTimeout(initAllPromoSwipers, 50);
                });
              });
            });
          } else {
            // First time setup - just show the panel
            tab.classList.add('is-active');
            tab.setAttribute('aria-selected', 'true');
            targetPanel.classList.add('is-active');
            // Initialize swiper for initially active panel
            setTimeout(initAllPromoSwipers, 50);
          }
        });
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileNavTabs);
  } else {
    initMobileNavTabs();
  }

  // Re-initialize when drawer opens (in case content is dynamically loaded)
  document.addEventListener('DOMContentLoaded', () => {
    const drawerButton = document.querySelector('.drawer__button');
    if (drawerButton) {
      drawerButton.addEventListener('click', () => {
        // Small delay to ensure drawer content is visible
        setTimeout(() => {
          initMobileNavTabs();
          setTimeout(initAllPromoSwipers, 150);
        }, 100);
      });
    }

    // Also listen for drawer open events
    document.addEventListener('drawer:opened', () => {
      setTimeout(() => {
        initMobileNavTabs();
        setTimeout(initAllPromoSwipers, 150);
      }, 100);
    });
  });
})();
